import { useComponentTexts, useValidationTexts } from "Store/texts/hooks";

import { WrapMdMarginBottom } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { useTexts } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { TextLanguage } from "Store/texts/interfaces";
import { formBooleanToBoolean } from "Utils/formUtils";
import { getError } from "Utils/productUtils";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagCabinRental } from "Utils/unleash/flags";
import { FormikProps } from "formik";
import React from "react";

interface Rental {
  rentalTimeExceedsOneMonthAYear?: BooleanFormType;
  hasRental?: BooleanFormType;
}

interface Props<T extends Rental = Rental> {
  formProps: FormikProps<T>;
  lang: TextLanguage;
}

export const RentalQuestion = ({
  formProps,
  lang,
}: Props): React.ReactElement => {
  const { getText } = useTexts();

  const [
    {
      formComponentsCabinProducts: { rentalTime },
    },
  ] = useComponentTexts();

  const [{ alertTitle }] = useValidationTexts();
  const enableRentalToggle = useUnleashFeatureFlag(
    FeatureFlagCabinRental.ENABLE_CABIN_RENTAL,
  );

  return enableRentalToggle ? (
    <RadioButtonTrueFalse
      name="hasRental"
      id="hasRental"
      hint={getText("cabinform.hint.hasrental")}
      label={getText("cabinform.label.hasrental")}
      options={getYesOrNoOptions("hasRental-yes", "hasRental-no")}
      direction="vertical"
      error={getError("hasRental", formProps)}
    />
  ) : (
    <>
      <RadioButtonTrueFalse
        name="rentalTimeExceedsOneMonthAYear"
        id="rentalTimeExceedsOneMonthAYear"
        hint={rentalTime.hint[lang]}
        label={rentalTime.label[lang]}
        options={getYesOrNoOptions(
          "rentalTimeExceedsOneMonthAYear-yes",
          "rentalTimeExceedsOneMonthAYear-no",
        )}
        direction="vertical"
        error={getError("rentalTimeExceedsOneMonthAYear", formProps)}
      />
      {formBooleanToBoolean(
        formProps.values.rentalTimeExceedsOneMonthAYear,
      ) && (
        <WrapMdMarginBottom>
          <ContactUsAlert
            description={rentalTime.validation[lang]}
            title={alertTitle[lang]}
            alertId="rentalTimeExceedsOneMonthAYear"
          />
        </WrapMdMarginBottom>
      )}
    </>
  );
};
